import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'

Vue.use(VueSweetalert2)

const Alert = {
  install (Vue, options) {
    Vue.prototype.$alert = function (options) {
      return Vue.swal(options)
    }

    Vue.prototype.$confirm = function (heading, text) {
      return Vue.swal({
        title: heading,
        text: text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#ebebeb',
        confirmButtonText: 'Ja',
        cancelButtonText: 'Avbryt'
      })
    }

    Vue.prototype.$infoPopup = function (heading, html, options) {
      const defaults = {
        icon: 'info',
        showCancelButton: false,
        // confirmButtonColor: '#d33',
        confirmButtonText: 'Stäng'
      }

      options = Object.assign(defaults, options)

      options.title = heading || options.title
      options.html = html || options.html

      return Vue.swal(options)
    }

    Vue.prototype.$closeAlert = function () {
      Vue.swal.close()
    }
  }
}

export default Alert



// WEBPACK FOOTER //
// ./src/plugins/alert.js